// frontend/src/graphql/analytics.js
import { gql } from '@apollo/client';

export const TRACK_PAGE_VIEW = gql`
  mutation TrackPageView(
    $pageUrl: String!
    $sessionId: String!
    $pageTitle: String
    $tourId: ID
    $parkId: ID
  ) {
    trackPageView(
      pageUrl: $pageUrl
      sessionId: $sessionId
      pageTitle: $pageTitle
      tourId: $tourId
      parkId: $parkId
    ) {
      success
    }
  }
`;

export const TRACK_SEARCH = gql`
  mutation TrackSearch(
    $query: String!
    $searchType: String!
    $sessionId: String!
    $resultsCount: Int!
  ) {
    trackSearch(
      query: $query
      searchType: $searchType
      sessionId: $sessionId
      resultsCount: $resultsCount
    ) {
      success
    }
  }
`;
